// extracted by mini-css-extract-plugin
module.exports = {"logo":"header-tinaba-module--logo--8Ywme","container":"header-tinaba-module--container--eHCbp"};